import * as React from "react";
import { observer } from "mobx-react";
import { UitkCard, UitkCardMedia, UitkCardLink } from "uitk-react-cards";
import { UitkImage, UitkFigure, UitkFigureAspectRatioType } from "uitk-react-images";
import { CampaignByIdQuery } from "../../../../../../__generated__/api";
import Offers = CampaignByIdQuery.Offers;
import { Action } from "components/utility/analytics/FlexAnalyticsUtils";
import { TrackedLink } from "components/utility/analytics/TrackedLink";
import { destinationOfferItem } from "../../Common/MerchCampaignCard/MerchCampaignCard";

export interface VRCardProps {
  offer: Offers;
  productType: string;
  cardIndex: number;
  campaignIndex: number;
  displayPropertyCount?: boolean;
  moduleName: string;
}

export const VRCard = observer(
  ({ offer, productType, cardIndex, campaignIndex, moduleName, displayPropertyCount }: VRCardProps) => {
    if (offer.__typename !== "DestinationOfferItem") {
      return null;
    }

    const offerItem = destinationOfferItem(productType, offer);

    if (offerItem === null || offerItem === undefined) {
      return null;
    }

    return (
      <>
        <UitkCard className="VRCard uitk-flex-justify-content-flex-start uitk-flex-column" withBorder={false}>
          <UitkCardMedia>
            <UitkFigure
              ratio={UitkFigureAspectRatioType.R16_9}
              className="uitk-card-aloha-roundcorner-bottom-left uitk-card-aloha-roundcorner-bottom-right"
            >
              <UitkImage src={offer.image.url} alt={offer.image.description} />
            </UitkFigure>
            <UitkCardLink>
              <TrackedLink
                moduleName={moduleName}
                action={Action.CLICK}
                href={offerItem?.actionLink.href}
                rfrr={`card-${campaignIndex}-${cardIndex}`}
              >
                {offer.name}
              </TrackedLink>
            </UitkCardLink>
          </UitkCardMedia>
          <div className="uitk-card-content uitk-cell all-t-padding-one">
            <h3 className="uitk-type-heading-400">{offer.name}</h3>
            {displayPropertyCount && offer.propertyCount && (
              <div className="uitk-type-paragraph-300">{offer.propertyCount}</div>
            )}
          </div>
        </UitkCard>
      </>
    );
  }
);
